module.exports = __webpack_public_path__ + "img/scroll-solid.6577fc14.svg";